import axios from '../config/axios'

const API_BASE = '/vehicle-contract-payments'

const vehicleContractPaymentService = {
  // Get all payments for a contract
  getByContract: (contractId, filters = {}) => {
    return axios.get(API_BASE, {
      params: { vehicle_contract_id: contractId, ...filters }
    })
  },

  // Get single payment
  getOne: (paymentId) => {
    return axios.get(`${API_BASE}/${paymentId}`)
  },

  // Create new payment
  create: (data) => {
    return axios.post(API_BASE, data)
  },

  // Update payment
  update: (paymentId, data) => {
    return axios.put(`${API_BASE}/${paymentId}`, data)
  },

  // Delete payment
  delete: (paymentId) => {
    return axios.delete(`${API_BASE}/${paymentId}`)
  },

  // Get payment receipt image
  getReceiptImage: (paymentId) => {
    return axios.get(`${API_BASE}/${paymentId}/receipt`, {
      responseType: 'blob'
    })
  }
}

export default vehicleContractPaymentService
